import React, { useState, useEffect } from "react";
import { withRouter, Redirect } from "react-router";
import { callApi } from "../../lib/utils";
import { StyleSheet, css } from "aphrodite";
import { Spinner } from "react-bootstrap";

const Landing = (props) => {
    /*const [state, setState] = useState({
        loading: true,
    });*/

    /*useEffect(() => {
        callApi("/isAuthenticated", {}, "POST")
            .then((res) => {
                console.log("res: ", res);
                if (res.status === 440) {
                    window.location = "/login";
                }
            })
            .catch((e) => {
                console.log("e: ", e);
            });
    }, []);*/

    return (
        <div>
            {props.loading ? (
                <div className={css([styles.spinner])}>
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    />
                    Loading...
                </div>
            ) : (
                <Redirect to={"/dashboard"}></Redirect>
                // <span>Redirecting to Home Page...</span>
            )}
        </div>
    );
};

export default withRouter(Landing);

const styles = StyleSheet.create({
    spinner: {
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
    },
});
